/**
 * Menu Drawer Vue Component
 * Support Widget for the mobile menu drawer
 * Uses Vue 3 global build (vue.global.prod.js)
 */

(function() {
  'use strict';

  // Wait for Vue to be available
  function initWhenReady() {
    if (typeof Vue === 'undefined') {
      // Vue not loaded yet, wait and retry
      setTimeout(initWhenReady, 50);
      return;
    }

    const { createApp, h } = Vue;

    // Support Widget Component
    const SupportWidget = {
      name: 'SupportWidget',
      props: {
        avatar: { type: String, default: '' },
        heading: { type: String, default: 'Fragen?' },
        description: { type: String, default: '' },
        phone: { type: String, default: '' },
        phoneDisplay: { type: String, default: '' },
        email: { type: String, default: '' },
        emailLabel: { type: String, default: 'E-mail schreiben' },
        bgColor: { type: String, default: '#f8f8f8' },
        textColor: { type: String, default: '#111111' },
        accentColor: { type: String, default: '#F36917' }
      },
      setup: function(props) {
        var cleanPhoneNumber = function(phone) {
          if (!phone) return '';
          return phone.replace(/[\s()\-]/g, '');
        };

        return function() {
          return h('div', {
            class: 'mrSupportWidget',
            style: {
              '--sw-bg': props.bgColor,
              '--sw-text': props.textColor,
              '--sw-accent': props.accentColor
            }
          }, [
            // Avatar
            props.avatar ? h('div', { class: 'mrSupportWidget__avatar' }, [
              h('img', {
                src: props.avatar,
                alt: '',
                width: 48,
                height: 48,
                loading: 'lazy'
              })
            ]) : null,
            // Content
            h('div', { class: 'mrSupportWidget__content' }, [
              // Heading
              props.heading ? h('h4', { class: 'mrSupportWidget__heading' }, props.heading) : null,
              // Description
              props.description ? h('p', { class: 'mrSupportWidget__description' }, props.description) : null,
              // Phone
              props.phone ? h('a', {
                href: 'tel:' + cleanPhoneNumber(props.phone),
                class: 'mrSupportWidget__phone'
              }, props.phoneDisplay || props.phone) : null,
              // Email
              props.email ? h('a', {
                href: 'mailto:' + props.email,
                class: 'mrSupportWidget__email'
              }, props.emailLabel) : null
            ].filter(Boolean))
          ].filter(Boolean));
        };
      }
    };

    // Menu Drawer Component (wrapper for future enhancements)
    const MenuDrawer = {
      name: 'MenuDrawer',
      components: {
        SupportWidget: SupportWidget
      },
      props: {
        sectionId: { type: String, required: true },
        supportSettings: { type: Object, default: function() { return {}; } }
      },
      setup: function(props) {
        return function() {
          return h('div', { class: 'mrMenuDrawer__vueWrapper' }, [
            Object.keys(props.supportSettings).length > 0 ? h(SupportWidget, props.supportSettings) : null
          ].filter(Boolean));
        };
      }
    };

    /**
     * Initialize Support Widget on a specific element
     * @param {string} elementId - The ID of the mount element
     * @param {object} settings - Widget configuration
     * @returns {object|null} Vue app instance or null
     */
    function initSupportWidget(elementId, settings) {
      var mountEl = document.getElementById(elementId);
      if (!mountEl) {
        console.warn('[MenuDrawerVue] Mount element #' + elementId + ' not found');
        return null;
      }

      // Clear any existing content (Liquid fallback)
      mountEl.innerHTML = '';

      var app = createApp(SupportWidget, settings);
      var instance = app.mount(mountEl);

      // Store reference for potential cleanup
      mountEl.__vueApp__ = app;

      return instance;
    }

    /**
     * Initialize Menu Drawer Vue enhancements
     * @param {string} sectionId - The section ID
     * @param {object} config - Configuration object
     * @returns {object|null} Vue app instance or null
     */
    function initMenuDrawer(sectionId, config) {
      config = config || {};
      var containerId = 'mr-menu-vue-' + sectionId;
      var mountEl = document.getElementById(containerId);

      if (!mountEl) {
        console.warn('[MenuDrawerVue] Mount element #' + containerId + ' not found');
        return null;
      }

      var app = createApp(MenuDrawer, {
        sectionId: sectionId,
        supportSettings: config.support || {}
      });

      var instance = app.mount(mountEl);
      mountEl.__vueApp__ = app;

      return instance;
    }

    /**
     * Destroy a Vue app instance mounted on an element
     * @param {string} elementId - The ID of the mount element
     */
    function destroyApp(elementId) {
      var mountEl = document.getElementById(elementId);
      if (mountEl && mountEl.__vueApp__) {
        mountEl.__vueApp__.unmount();
        delete mountEl.__vueApp__;
      }
    }

    // Expose to window for global usage
    window.MenuDrawerVue = {
      SupportWidget: SupportWidget,
      MenuDrawer: MenuDrawer,
      initSupportWidget: initSupportWidget,
      initMenuDrawer: initMenuDrawer,
      destroyApp: destroyApp
    };

    // Auto-initialize support widgets
    var containers = document.querySelectorAll('[data-vue-support-widget]');
    containers.forEach(function(container) {
      try {
        var settingsStr = container.dataset.vueSupportWidget;
        if (settingsStr) {
          var settings = JSON.parse(settingsStr);
          initSupportWidget(container.id, settings);
        }
      } catch (e) {
        console.error('[MenuDrawerVue] Failed to parse settings:', e);
      }
    });
  }

  // Start initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();
